import { IFormData, IFormSchema, ISchemaContext } from "..";


export interface IKnownFormContext {
    emptyValue: string;
    currentFormData: IFormData;
    mode: ISchemaContext["mode"];

};

export type IFormContext = Partial<IKnownFormContext> & { [key: string]: any };

export type IStrictFormContext = IKnownFormContext & { [key: string]: any };



export const FormContextMapper = {
    toStrictFormContext: (formContext: IFormContext = {}, formSchema: IFormSchema, currentFormData: IFormData): IStrictFormContext => {
        const { emptyValue } = formContext;
        return {
            ...formContext,
            emptyValue: emptyValue || formSchema.emptyValue || "-",
            currentFormData,
            mode: formContext.mode || "form"

        };
    },
};

export const transformFormContext = (formContext: any, formSchema: IFormSchema) => {
    return {
        ...(formContext || {}),
        emptyValue: formContext.emptyValue || formSchema.emptyValue || "-"
    }
}